import { MouseEvent } from "react";
import { Colors } from "../../../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { filterColor } from "../../../../../../reduxToolkit/reducers/eCommerce/filterSlice";
import { getColors } from "../../../../../../utils/ecommerce";

// This component renders a list of colors in the product item that allows users to select a product color.
const ColorsFilter = () => {
  const { productItem } = useAppSelector((state) => state.product);
  const dispatch = useAppDispatch();
  const colors = getColors(productItem);

  const handleColors = (event: MouseEvent<HTMLLIElement>, color: string) => {
    const elem = document.getElementsByClassName("color-selector")[0].getElementsByTagName("li");
    for (let i = 0; i < elem.length; i++) {
      elem[i].classList.remove("active");
    }
    (event.target as Element).classList.add("active");
    dispatch(filterColor(color));
  };

  return (
    <div className="product-filter slider-product">
      <h4 className="mb-1">{Colors}</h4>
      <div className="color-selector">
        <ul className="d-flex flex-row gap-1">
          {colors.map((color, i) => (
            <li className={color} title={color} onClick={(e: MouseEvent<HTMLLIElement, globalThis.MouseEvent>) => handleColors(e, color)} key={i}></li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ColorsFilter;
